import { type IReport } from "@components/feature/Aside/types";
import { apiDelete, apiGet, apiPost, apiPut } from "@services/newApi/typed";

export const getReportDetails = async (
  reportId: number,
  signal?: AbortSignal,
) => {
  return await apiGet<IReport>(`/reports/${reportId}`, { ...(signal !== undefined && { signal }) });
};

export const createOrUpdateReport = async (
  name: string,
  label?: string,
  reportId?: number,
) => {
  if (reportId) {
    return await apiPut<{ report_id: number }>(`/reports/${reportId}`, {
      name,
      label,
    });
  }
  // CREATE: backend tem `POST /reports` (canônico) com PUT como alias DEPRECATED.
  // Frontend usa POST.
  return await apiPost<{ report_id: number }>(`/reports`, { name, label });
};

export const createOrUpdateReportParams = async (
  params: any,
  reportId?: number,
) => {
  return await apiPut<any>(`/reports/${reportId}/params`, params);
};

export const removeReport = async (reportId: number) => {
  return await apiDelete<any>(`/reports/${reportId}`);
};
